import { ChangeDetectionStrategy, Component, computed, inject, Input, signal } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'opac-author-card-item',
  templateUrl: './author-card-item.component.html',
  styleUrls: ['./author-card-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthorCardItemComponent {
  private static readonly VectorImagesCount = 6;

  private readonly router = inject(Router);

  private vectorImageIndex = signal<number>(0);

  /**
   * Determines card background
   */
  @Input() backgroundColor!: string;

  /**
   * Determines background svg image index
   */
  @Input() set backgroundVectorImageIndex(value: number) {
    this.vectorImageIndex.set(value);
  }

  /**
   * Author name
   */
  @Input() name!: string;

  // Based on index, returns complete css background-image url string
  backgroundImageUrl = computed(() => {
    const imageIndex = this.vectorImageIndex() % AuthorCardItemComponent.VectorImagesCount;
    return `url("/assets/author-card-item-backgrounds/bg_author_${imageIndex}.svg")`;
  });

  goToAuthor(author: string) {
    const queryParams = {
      limit: 24,
      offset: 0,
      facets: `autor_facet_ss:"${author}"`,
      order: 'fechaModifica_dt:desc',
    };

    this.router.navigate(['/results'], { queryParams: queryParams });
  }
}
